import React from 'react';

/**
 * Spotify-style blurred ambient glow rendered behind media.
 * `rgb` is an "r,g,b" string (from useDominantColor).
 */
export const AmbientGlow = ({ rgb = '34,197,94', intensity = 0.22, className = '' }) => (
  <div
    aria-hidden
    className={`absolute inset-0 pointer-events-none ${className}`}
    style={{
      background: `radial-gradient(65% 55% at 50% 30%, rgba(${rgb},${intensity}), transparent 75%)`,
      filter: 'blur(48px)',
      transform: 'translateZ(0)',
    }}
  />
);
